module.exports = __webpack_public_path__ + "media/images/choose-file-d4ec42c76e9ff941c5fa0e624cd16ae4.gif";